export const CHALLENGE_TEMPLATES = [
  {
    id: 'finance_30',
    name: 'Controle Financeiro em 30 Dias',
    category: 'Finanças',
    duration: '30',
    description: 'Desenvolva hábitos financeiros saudáveis e organize suas finanças em 30 dias.',
    tasks: [
      { id: 1, text: 'Criar planilha de gastos', completed: false },
      { id: 2, text: 'Registrar todas as despesas do dia', completed: false },
      { id: 3, text: 'Definir metas financeiras mensais', completed: false },
      { id: 4, text: 'Criar orçamento mensal', completed: false },
      { id: 5, text: 'Separar dinheiro para emergências', completed: false }
    ]
  },
  {
    id: 'health_21',
    name: '21 Dias de Saúde e Bem-estar',
    category: 'Saúde',
    duration: '21',
    description: 'Transforme sua saúde em 21 dias com hábitos saudáveis e exercícios regulares.',
    tasks: [
      { id: 1, text: 'Beber 2L de água por dia', completed: false },
      { id: 2, text: 'Fazer 30 minutos de exercício', completed: false },
      { id: 3, text: 'Dormir 8 horas por noite', completed: false },
      { id: 4, text: 'Fazer alongamentos matinais', completed: false },
      { id: 5, text: 'Comer 3 porções de vegetais', completed: false }
    ]
  },
  {
    id: 'meditation_10',
    name: 'Iniciando na Meditação',
    category: 'Meditação',
    duration: '10',
    description: 'Comece sua jornada na meditação com práticas diárias simples.',
    tasks: [
      { id: 1, text: 'Meditar por 5 minutos', completed: false },
      { id: 2, text: 'Praticar respiração consciente', completed: false },
      { id: 3, text: 'Encontrar local calmo para meditar', completed: false },
      { id: 4, text: 'Usar app de meditação guiada', completed: false }
    ]
  },
  {
    id: 'reading_15',
    name: 'Hábito de Leitura em 15 Dias',
    category: 'Leitura',
    duration: '15',
    description: 'Desenvolva o hábito da leitura diária e expanda seus conhecimentos.',
    tasks: [
      { id: 1, text: 'Ler 10 páginas por dia', completed: false },
      { id: 2, text: 'Criar lista de livros para ler', completed: false },
      { id: 3, text: 'Definir horário fixo para leitura', completed: false },
      { id: 4, text: 'Fazer anotações sobre a leitura', completed: false }
    ]
  },
  {
    id: 'exercise_30',
    name: 'Condicionamento Físico em 30 Dias',
    category: 'Exercícios Físicos',
    duration: '30',
    description: 'Melhore seu condicionamento físico com exercícios progressivos.',
    tasks: [
      { id: 1, text: 'Fazer 20 flexões', completed: false },
      { id: 2, text: 'Fazer 30 agachamentos', completed: false },
      { id: 3, text: 'Correr/caminhar por 20 minutos', completed: false },
      { id: 4, text: 'Fazer exercícios de core', completed: false },
      { id: 5, text: 'Alongamento pós-treino', completed: false }
    ]
  },
  {
    id: 'nutrition_21',
    name: 'Reeducação Alimentar',
    category: 'Alimentação',
    duration: '21',
    description: 'Transforme seus hábitos alimentares com escolhas mais saudáveis.',
    tasks: [
      { id: 1, text: 'Preparar marmitas saudáveis', completed: false },
      { id: 2, text: 'Evitar alimentos ultraprocessados', completed: false },
      { id: 3, text: 'Comer frutas no café da manhã', completed: false },
      { id: 4, text: 'Planejar refeições da semana', completed: false }
    ]
  },
  {
    id: 'discipline_14',
    name: 'Disciplina Diária',
    category: 'Disciplina',
    duration: '14',
    description: 'Desenvolva uma rotina disciplinada e produtiva.',
    tasks: [
      { id: 1, text: 'Acordar no mesmo horário', completed: false },
      { id: 2, text: 'Fazer a cama ao acordar', completed: false },
      { id: 3, text: 'Planejar o dia pela manhã', completed: false },
      { id: 4, text: 'Seguir horários estabelecidos', completed: false }
    ]
  },
  {
    id: 'mindset_21',
    name: 'Mentalidade Positiva',
    category: 'Mentalidade',
    duration: '21',
    description: 'Cultive uma mentalidade positiva e resiliente.',
    tasks: [
      { id: 1, text: 'Escrever 3 gratidões diárias', completed: false },
      { id: 2, text: 'Praticar afirmações positivas', completed: false },
      { id: 3, text: 'Visualizar objetivos diariamente', completed: false },
      { id: 4, text: 'Celebrar pequenas vitórias', completed: false }
    ]
  },
  {
    id: 'productivity_15',
    name: 'Produtividade Máxima',
    category: 'Produtividade',
    duration: '15',
    description: 'Aumente sua produtividade com técnicas comprovadas.',
    tasks: [
      { id: 1, text: 'Usar técnica Pomodoro', completed: false },
      { id: 2, text: 'Criar lista de tarefas diárias', completed: false },
      { id: 3, text: 'Eliminar distrações', completed: false },
      { id: 4, text: 'Definir prioridades do dia', completed: false }
    ]
  },
  {
    id: 'sleep_14',
    name: 'Sono de Qualidade',
    category: 'Sono',
    duration: '14',
    description: 'Melhore a qualidade do seu sono com hábitos noturnos saudáveis.',
    tasks: [
      { id: 1, text: 'Estabelecer horário fixo para dormir', completed: false },
      { id: 2, text: 'Evitar telas 1h antes de dormir', completed: false },
      { id: 3, text: 'Criar ritual noturno relaxante', completed: false },
      { id: 4, text: 'Manter quarto escuro e silencioso', completed: false }
    ]
  }
]; 